// Node map types for Slay the Spire / FTL style branching path system

export type NodeType = "regular" | "boss" | "event"
export type NodeStatus = "locked" | "available" | "current" | "completed"
export type EventType = "shop" | "pelf"

export interface MapNode {
  id: string
  row: number                    // 0 = start row (bottom), N = boss row (top)
  column: number                 // Position within row (0-4)
  type: NodeType
  status: NodeStatus
  levelIndex: number | null      // Index into levels[] for regular/boss nodes
  eventType?: EventType          // For event nodes (shop or pelf)
  eventRevealed?: boolean        // True after traveling to this event node (reveals actual type)
  pelfItemId?: string            // For pelf events: the item ID that will be rewarded
  position: { x: number; y: number }  // Rendered position with jitter applied
}

export interface MapEdge {
  fromNodeId: string
  toNodeId: string
}

export interface MapState {
  seed: string                   // For reproducible generation
  nodes: MapNode[]
  edges: MapEdge[]
  currentNodeId: string | null   // Node player is currently at (null = start)
  visitedNodeIds: string[]       // History of completed nodes
  totalRows: number              // 12-15 rows
  pendingItemDrop?: string       // Item ID to drop at hero position when level starts (inventory was full)
}

export interface MapConfig {
  minRows: number                // 12
  maxRows: number                // 15
  columns: number                // 5
  regularPercent: number         // 0.70
  bossPercent: number            // 0.15
  eventPercent: number           // 0.15
  startingNodes: number          // 1 starting node
}

export const DEFAULT_MAP_CONFIG: MapConfig = {
  minRows: 12,
  maxRows: 15,
  columns: 5,
  regularPercent: 0.70,
  bossPercent: 0.15,
  eventPercent: 0.15,
  startingNodes: 1,
}
